import { combineReducers } from 'redux'
import createRatingReducer, { createRatingActions } from '@app-store/slices/momentum/createRating'
import deleteRatingReducer, { deleteRatingActions } from '@app-store/slices/momentum/deleteRating'
import editRatingReducer, { editRatingActions } from '@app-store/slices/momentum/editRating'
import listRatingReducer, { listRatingActions } from '@app-store/slices/momentum/listRating'
import oneRatingReducer, { oneRatingActions } from '@app-store/slices/momentum/oneRating'
import notHappenedReducer, { notHappenedActions } from '@app-store/slices/momentum/notHappened'

export const momentumReducer = combineReducers({
    create: createRatingReducer,
    delete: deleteRatingReducer,
    edit: editRatingReducer,
    list: listRatingReducer,
    one: oneRatingReducer,
    notHappened: notHappenedReducer
})

export const momentumActions = {
    create: createRatingActions,
    delete: deleteRatingActions,
    edit: editRatingActions,
    list: listRatingActions,
    one: oneRatingActions,
    notHappened: notHappenedActions
}
